function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M246 0C110 0 0 112 0 249c0 138 110 250 246 250 135 0 246-112 246-250C492 112 381 0 246 0zm0 421c-21 0-38-17-38-39 0-21 17-38 38-38s38 17 38 38c0 22-17 39-38 39zm38-145c0 21-17 39-38 39s-38-18-38-39V116c0-21 17-38 38-38s38 17 38 38z"
}));